import React from 'react';
import './field-row.css';
export function FieldRow({ children }) {
    return (React.createElement("div", { className: "field-row" }, children));
}
